"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var immutable_1 = require("immutable");
exports.DEFAULT_STATE = immutable_1.fromJS({
    locale: 'en-US',
    messageProperties: {},
    supportedLocales: []
});
function localization(state) {
    if (state === void 0) { state = exports.DEFAULT_STATE; }
    return state;
}
exports.localization = localization;
function bootstrap(_a) {
    var locale = _a.locale, messageProperties = _a.messageProperties, supportedLocales = _a.supportedLocales;
    return immutable_1.fromJS({
        localization: {
            locale: locale,
            messageProperties: messageProperties,
            supportedLocales: supportedLocales
        }
    });
}
exports.bootstrap = bootstrap;
function mapStateToProps(reducer) {
    return function (state) {
        var locState = state.get(reducer);
        return {
            messages: locState.get('messageProperties')
        };
    };
}
exports.mapStateToProps = mapStateToProps;
exports.selectMessages = function (state) { return state.getIn(['localization', 'messageProperties']); };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibG9jYWxpemF0aW9uLnJlZHVjZXIuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvY2xpZW50L3JlZHVjZXJzL2xvY2FsaXphdGlvbi5yZWR1Y2VyLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBQUEsdUNBQWlDO0FBUXBCLFFBQUEsYUFBYSxHQUFHLGtCQUFNLENBQUM7SUFDaEMsTUFBTSxFQUFFLE9BQU87SUFDZixpQkFBaUIsRUFBRSxFQUFFO0lBQ3JCLGdCQUFnQixFQUFFLEVBQUU7Q0FDdkIsQ0FBQyxDQUFDO0FBRUgsU0FBZ0IsWUFBWSxDQUFDLEtBQXFCO0lBQXJCLHNCQUFBLEVBQUEsUUFBUSxxQkFBYTtJQUM5QyxPQUFPLEtBQUssQ0FBQztBQUNqQixDQUFDO0FBRkQsb0NBRUM7QUFFRCxTQUFnQixTQUFTLENBQUMsRUFBNkM7UUFBNUMsa0JBQU0sRUFBRSx3Q0FBaUIsRUFBRSxzQ0FBZ0I7SUFDbEUsT0FBTyxrQkFBTSxDQUFDO1FBQ1YsWUFBWSxFQUFFO1lBQ1YsTUFBTSxRQUFBO1lBQ04saUJBQWlCLG1CQUFBO1lBQ2pCLGdCQUFnQixrQkFBQTtTQUNuQjtLQUNKLENBQUMsQ0FBQztBQUNQLENBQUM7QUFSRCw4QkFRQztBQUVELFNBQWdCLGVBQWUsQ0FBQyxPQUFPO0lBQ25DLE9BQU8sVUFBQSxLQUFLO1FBQ1IsSUFBTSxRQUFRLEdBQUcsS0FBSyxDQUFDLEdBQUcsQ0FBQyxPQUFPLENBQUMsQ0FBQztRQUNwQyxPQUFPO1lBQ0gsUUFBUSxFQUFFLFFBQVEsQ0FBQyxHQUFHLENBQUMsbUJBQW1CLENBQUM7U0FDOUMsQ0FBQztJQUNOLENBQUMsQ0FBQztBQUNOLENBQUM7QUFQRCwwQ0FPQztBQUVZLFFBQUEsY0FBYyxHQUFHLFVBQUEsS0FBSyxJQUFJLE9BQUEsS0FBSyxDQUFDLEtBQUssQ0FBQyxDQUFDLGNBQWMsRUFBRSxtQkFBbUIsQ0FBQyxDQUFDLEVBQWxELENBQWtELENBQUMifQ==